<template>
  <div class="section__form">
    <Loading v-if="isLoading"/>
    <div v-else>
      <h2 v-if="firstName">Hey {{firstName}}</h2>
      <h2 v-else>{{firstName}}</h2>

      <p v-if="profileImg" class="container__avatar">
        <img v-bind:src="profileImg" alt="user avatar" class="img__avatar"/>
      </p>
      <p v-if="firstName && lastName">
        You're logged in as {{firstName}} {{lastName}}
      </p>
      <p class="btn" @click="goToMyAccount">
        My account
      </p>
      <LogoutButton />
    </div>
  </div>
</template>

<script>
import Loading from '@/components/elements/Loading';
import LogoutButton from '@/components/elements/LogoutButton';
import { getUserByAccessToken } from '@/helpers/UserAPI';
import { redirect } from '@/helpers/helpersUsingStore';
import get from "lodash/get";

export default {
  name: "LoggedIn",
  data: function() {
    return {
      isUserLoaded: false,
      firstName: 'Welcome back!',
      lastName: '',
      profileImg: '',
      isLoading: true
    };
  },
  components: {
    Loading,
    LogoutButton
  },
  created() {
    const pageUrl = parent !== window ? document.referrer : window.location.href;
    [
      'login', 'log-in', 'signup', 'sign-up'
    ].forEach((urlPartial) => {
      if(pageUrl.indexOf(urlPartial) >= 0){
        redirect('/app/#');
        return;        
      }
    });

    getUserByAccessToken()
      .then((res) => {
        this.isLoading = false;
        if(res === undefined) {
          return;
        }

        this.firstName = get(res, 'firstName');
        this.lastName = get(res, 'lastName');
        this.profileImg = get(res, 'avatars.m');
         this.isUserLoaded = true;
      });
    
  },
  methods: {
    goToMyAccount: function() {
      redirect('/app/#');
    }
  }
}
</script>

<style lang="sass">
  .container__avatar {
    height: 96px;
  }

  .img__avatar {
    width: 96px;
    height: 100%;
    border-radius: 100%;
  }
</style>

